<template>
    <div v-bind:class="listClass" id="template-list">
        <v-container fluid>
            <v-row dense class="template-list">
                <templateElementTile v-if="add === true"
                             :template="placeholderData"
                             :view-privilege="true"
                             :edit-privilege="false"
                             :delete-privilege="false"
                             :small="true"
                             mode="tiles"
                             key="placeholder"
                             :element-class="elementClass"
                             :drag-drop="true">
                </templateElementTile>

                <template v-for="(template, key) in templates" >
                    <templateElementTile :template="template"
                                 :view-privilege="true"
                                 :edit-privilege="false"
                                 :delete-privilege="false"
                                 :small="true"
                                 mode="tiles"
                                 :key="key"
                                 :element-class="elementClass"
                                 :drag-drop="true">
                    </templateElementTile>
                </template>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import templateElementTile from "./templateElementTile.vue";

    export default {
        props: [
            'templates',
            'classes',
            'elementClass',
            'add'
        ],
        components: {
            templateElementTile
        },
        data: function () {
            return {
                t_new: Lang.langGet("New"),
                t_validity: Lang.langGet("Validity"),
                t_added: Lang.langGet("Added"),
                t_modified: Lang.langGet("Modified"),
                placeholderData: {
                    first_revision_id: 0,
                    last_revision_id: 0,
                    last_preview: '',
                    is_placeholder: true,
                    parameters: {},
                    name: Lang.langGet("Create New"),
                    created_at: '',
                    updated_at: '',
                    tags: []
                }
            }
        },
        computed: {
            listClass: function () {
                return this.classes + ' col-md-12';
            },
        },
    }
</script>
